import { render, staticRenderFns } from "./provincialHead.vue?vue&type=template&id=efa52254"
import script from "./provincialHead.vue?vue&type=script&lang=js"
export * from "./provincialHead.vue?vue&type=script&lang=js"
import style0 from "./provincialHead.vue?vue&type=style&index=0&id=efa52254&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports